import { DataRequirements, } from "../data.requirements";
import * as i0 from "@angular/core";
import * as i1 from "../mappers/player-edit-mapper";
import * as i2 from "../data.requirements";
export class EditPlayerUseCase {
    constructor(mapper, data) {
        this.mapper = mapper;
        this.data = data;
    }
    run(playerId, playerData) {
        return this.data.editPlayer(playerId, playerData).pipe(this.mapper.map);
    }
}
EditPlayerUseCase.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function EditPlayerUseCase_Factory() { return new EditPlayerUseCase(i0.ɵɵinject(i1.PlayerEditMapper), i0.ɵɵinject(i2.DataRequirementsInjectionToken)); }, token: EditPlayerUseCase, providedIn: "root" });
